/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code which indicates an improvement measure for a property.
 */
export type SapImprovementMeasureCodeUIDTOV0 = 'A' | 'A2' | 'A3' | 'B' | 'B4' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'J' | 'J2' | 'K' | 'L' | 'L2' | 'M' | 'N' | 'O' | 'O3' | 'P' | 'Q' | 'Q2' | 'R' | 'S' | 'T' | 'T2' | 'U' | 'V' | 'V2' | 'W' | 'W1' | 'W2' | 'X' | 'Y' | 'Y2' | 'Z1' | 'Z2' | 'Z3' | 'NR';

export const SapImprovementMeasureCodeUIDTOV0 = {
    A: 'A' as SapImprovementMeasureCodeUIDTOV0,
    A2: 'A2' as SapImprovementMeasureCodeUIDTOV0,
    A3: 'A3' as SapImprovementMeasureCodeUIDTOV0,
    B: 'B' as SapImprovementMeasureCodeUIDTOV0,
    B4: 'B4' as SapImprovementMeasureCodeUIDTOV0,
    C: 'C' as SapImprovementMeasureCodeUIDTOV0,
    D: 'D' as SapImprovementMeasureCodeUIDTOV0,
    E: 'E' as SapImprovementMeasureCodeUIDTOV0,
    F: 'F' as SapImprovementMeasureCodeUIDTOV0,
    G: 'G' as SapImprovementMeasureCodeUIDTOV0,
    H: 'H' as SapImprovementMeasureCodeUIDTOV0,
    I: 'I' as SapImprovementMeasureCodeUIDTOV0,
    J: 'J' as SapImprovementMeasureCodeUIDTOV0,
    J2: 'J2' as SapImprovementMeasureCodeUIDTOV0,
    K: 'K' as SapImprovementMeasureCodeUIDTOV0,
    L: 'L' as SapImprovementMeasureCodeUIDTOV0,
    L2: 'L2' as SapImprovementMeasureCodeUIDTOV0,
    M: 'M' as SapImprovementMeasureCodeUIDTOV0,
    N: 'N' as SapImprovementMeasureCodeUIDTOV0,
    O: 'O' as SapImprovementMeasureCodeUIDTOV0,
    O3: 'O3' as SapImprovementMeasureCodeUIDTOV0,
    P: 'P' as SapImprovementMeasureCodeUIDTOV0,
    Q: 'Q' as SapImprovementMeasureCodeUIDTOV0,
    Q2: 'Q2' as SapImprovementMeasureCodeUIDTOV0,
    R: 'R' as SapImprovementMeasureCodeUIDTOV0,
    S: 'S' as SapImprovementMeasureCodeUIDTOV0,
    T: 'T' as SapImprovementMeasureCodeUIDTOV0,
    T2: 'T2' as SapImprovementMeasureCodeUIDTOV0,
    U: 'U' as SapImprovementMeasureCodeUIDTOV0,
    V: 'V' as SapImprovementMeasureCodeUIDTOV0,
    V2: 'V2' as SapImprovementMeasureCodeUIDTOV0,
    W: 'W' as SapImprovementMeasureCodeUIDTOV0,
    W1: 'W1' as SapImprovementMeasureCodeUIDTOV0,
    W2: 'W2' as SapImprovementMeasureCodeUIDTOV0,
    X: 'X' as SapImprovementMeasureCodeUIDTOV0,
    Y: 'Y' as SapImprovementMeasureCodeUIDTOV0,
    Y2: 'Y2' as SapImprovementMeasureCodeUIDTOV0,
    Z1: 'Z1' as SapImprovementMeasureCodeUIDTOV0,
    Z2: 'Z2' as SapImprovementMeasureCodeUIDTOV0,
    Z3: 'Z3' as SapImprovementMeasureCodeUIDTOV0,
    Nr: 'NR' as SapImprovementMeasureCodeUIDTOV0
};

